import { Button, Flex, Tooltip } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Scene } from '@monorepo/types';
import { FunctionComponent } from 'react';
import { useVideoContext } from '../../../../hooks/use-video';
import { LoadingState, useLoading } from '@monorepo/react-components';
import { useTranslation } from 'react-i18next';

interface Props {
  scene?: Scene;
}

const SceneLayoutActions: FunctionComponent<Props> = ({ scene }) => {
  const { t } = useTranslation();
  const { createScene } = useVideoContext();
  const {
    loadingState: addSceneLoadingState,
    updateLoadingState: addSceneUpdateLoadingState,
  } = useLoading();

  const handleAddScene = async () => {
    try {
      addSceneUpdateLoadingState(LoadingState.Loading);

      await createScene({ sceneId: scene?._id });

      console.log('Add scene after:', scene?._id);
    } catch (e) {
      console.error('Failed to add scene:', e);
    } finally {
      addSceneUpdateLoadingState(LoadingState.Loaded);
    }
  };

  return (
    <Flex className={'scene-layout-actions'} justify="center" align="center">
      <Tooltip placement={'bottom'} title={t('videoEditor.scene.addNewScene')}>
        <Button
          loading={addSceneLoadingState === LoadingState.Loading}
          type="text"
          size="middle"
          icon={<PlusCircleOutlined />}
          onClick={handleAddScene}
        />
      </Tooltip>
    </Flex>
  );
};

export default SceneLayoutActions;
